import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { ModulosController } from '../../modulos-controller';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { IMyDrpOptions, IMyDateRangeModel, IMyDateRange } from 'mydaterangepicker';
import { ConvenioService } from '../../../../providers/convenio-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { UsuarioService } from '../../../../providers/usuario-service';

import { ModalArquivosPage } from '../../../modais/modal-arquivos/modal-arquivos';
import { FileService } from "../../../../providers/file-service";

declare var jsPDF: any;

@Component({
    selector: 'page-relacao-celebrados',
    templateUrl: 'relacao-celebrados.html',
    providers: [
        ConvenioService
    ]
})
export class ConvenioRelacaoCelebradosPage extends ModulosController {

    listaFatores: any = [];
    listaConvenio: any = [];
    // isJurisdicionado: any;
    // isCGE: boolean;

    myDatePickerVigencia: IMyDpOptions;
    myDateRangePickerOptions: IMyDrpOptions;
    myDatePickerPublicacaoConvenio: IMyDpOptions;
    myDatePickerDevolucaoSaldo: IMyDpOptions;

    tiposArquivosAceitos: string = "application/xls";

    selectedDateRange: IMyDateRange;

    placeholderTxt: string = '';
    selectedText: string = '';
    border: string = 'none';

    objetoConvenio: any = {
        "idConveniosCelebrados": 0,
        "sacc": "",
        "nomeConvenente": "",
        "dataInicialVigencia": "",
        "dataFinalVigencia": "",
        "valor": "",
        "saldoRemanescenteInstrumento": "",
        "justificativaInstrumento": "",
        "saldoRemanescenteDevolvido": "",
        "justificativaDevolvido": "",
        "dataDevolucaoSaldoRemanescente": "",
        "situacao": "",
        "justificativaSituacao": "",
        "dataPublicacaoConvenio": "",
        "extratos": [],
        "idModuloAnalise": 0 // alterar para codigo da Pca.
    }

    codigoModulo: any;

    objetoEdit: any = null;
    listEdit: any = [];

    analise: any = null;
    idModuloAnalise: any;

    loading: boolean = false;

    justificativaSaldoRemanescenteRequired: boolean = false;
    justificativaSaldoDevolvidoRequired: boolean = false;
    justificativaSituacaoRequired: boolean = false;

    @ViewChild('inputFileCM')
    inputFileCMVar: ElementRef;

    selecionarTodosChecked = false;
    
    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public navParams: NavParams,
        public convenioService: ConvenioService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService,
        private fileService: FileService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

        this.myDateRangePickerOptions = {
            dateFormat: 'dd/mm/yyyy',
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            firstDayOfWeek: 'su',
            showApplyBtn: false,
            showClearDateRangeBtn: false,
            selectBeginDateTxt: 'Selecione a Data de Início',
            selectEndDateTxt: 'Selecione a Data de Fim',
            openSelectorOnInputClick: true,
            editableDateRangeField: false,
            width: '100%'
            //disableUntil: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() - 1 }
        };

        this.myDatePickerVigencia = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false,
            componentDisabled: true,
            openSelectorTopOfInput: true,
            showSelectorArrow: false
        };

        this.myDatePickerPublicacaoConvenio = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false
            //disableUntil: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() - 1 }
        };


        this.myDatePickerDevolucaoSaldo = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false,
            openSelectorTopOfInput: true,
            showSelectorArrow: false
        };

        this.analise = this.navParams.get('analise');
        this.idModuloAnalise = this.navParams.get('analise').idModuloAnalise;
        this.codigoModulo = this.navParams.get('analise').idModuloPca;
        // this.isJurisdicionado = this.usuarioService.isJurisdicionado();
        // this.isCGE = this.usuarioService.isCGE();
        this.carregarModulo();
        this.setModuloId(6);
    }

    carregarModulo() {
        this.listar()
    }

    listar() {
        this.loading = true;
        this.convenioService.listarConvenioCelebrado().subscribe(data => {
            this.listaConvenio = data;
            this.selecionarTodosChecked = false;
            this.loading = false;
        }, error => {
            this.alertService.mostraAlerta("", "Houve um problema ao listar.");
            this.loading = false;
        });
    }

    onDatePickerDataPub(event: IMyDateModel) {
        if (event.jsdate === null) {
            this.objetoConvenio.dataPublicacaoConvenio = null;
        }
        else {
            this.objetoConvenio.dataPublicacaoConvenio = new Date(event.jsdate).toLocaleDateString('pt-br');
        }
    }

    onDatePickerDevolucaoSaldo(event: IMyDateModel) {
        if (event.jsdate === null) {
            this.objetoConvenio.dataDevolucaoSaldoRemanescente = null;
        }
        else {
            this.objetoConvenio.dataDevolucaoSaldoRemanescente = new Date(event.jsdate).toLocaleDateString('pt-br');
        }
    }

    onDateRangeChanged(event: IMyDateRangeModel) {

        if (event.formatted !== '') {

            this.border = '1px solid #CCC';

            this.objetoConvenio.dataInicialVigencia = new Date(event.beginJsDate).toLocaleDateString('pt-br');
            this.objetoConvenio.dataFinalVigencia = new Date(event.endJsDate).toLocaleDateString('pt-br');

            if (this.objetoConvenio.dataInicialVigencia == this.objetoConvenio.dataFinalVigencia) {
                this.objetoConvenio.dataInicialVigencia = '';
                this.objetoConvenio.dataFinalVigencia = '';
                this.clearDateRange();
                this.alertService.mostraAlerta("", "O fim da Vigência não pode ser igual ao início da Vigência.");
            }

        }
        else {
            this.selectedText = '';
            this.border = 'none';
        }
    }

    getCopyOfVigencia(): IMyDpOptions {
        return JSON.parse(JSON.stringify(this.myDatePickerVigencia));
    }

    clearDateRange(): void {
        this.selectedDateRange = null;
    }


    adicionarConvenio() {

        if (this.objetoConvenio.saldoRemanescenteDevolvido == null 
            || this.objetoConvenio.saldoRemanescenteDevolvido == undefined 
            || this.objetoConvenio.saldoRemanescenteDevolvido == '' 
            || isNaN(this.objetoConvenio.saldoRemanescenteDevolvido)) {
            this.objetoConvenio.saldoRemanescenteDevolvido = 0;
        }

        if (this.objetoConvenio.saldoRemanescenteInstrumento == null 
            || this.objetoConvenio.saldoRemanescenteInstrumento == undefined 
            || this.objetoConvenio.saldoRemanescenteInstrumento == '' 
            || isNaN(this.objetoConvenio.saldoRemanescenteInstrumento)) {
            this.objetoConvenio.saldoRemanescenteInstrumento = 0;
        }

        let checkDevolvido = true;
        let checkInstrumento = true;
        let checkSituacao = true;
        let check = true;

        if (this.objetoConvenio.saldoRemanescenteInstrumento != 0 
            && (this.objetoConvenio.justificativaInstrumento == null 
                || this.objetoConvenio.justificativaInstrumento == undefined 
                || this.objetoConvenio.justificativaInstrumento == '')) {
            checkInstrumento = false;
            this.alertService.mostraAlerta("", "A Justificativa do Saldo Remanescente do Instrumento deve ser preenchida devido ao valor do saldo ser diferente de zero.");
            return;
        }
        if (this.objetoConvenio.saldoRemanescenteDevolvido != 0 
            && (this.objetoConvenio.justificativaDevolvido == null 
                || this.objetoConvenio.justificativaDevolvido == undefined 
                || this.objetoConvenio.justificativaDevolvido == '')) {
            checkDevolvido = false;
            this.alertService.mostraAlerta("", "A Justificativa do Saldo Remanescente Devolvido deve ser preenchida devido ao valor do saldo ser diferente de zero.");
            return;
        }
        if (this.objetoConvenio.situacao == 'Inadimplente' 
            && (this.objetoConvenio.justificativaSituacao == null 
                || this.objetoConvenio.justificativaSituacao == undefined 
                || this.objetoConvenio.justificativaSituacao == '')) {
            checkSituacao = false;
            this.alertService.mostraAlerta("", "A Justificativa da Situação deve ser preenchida devido a situação ser Inadimplente.");
            return;
        }

        let objetoConvenio = {
            "idConveniosCelebrados": 0,
            "sacc": this.objetoConvenio.sacc.trim(),
            "nomeConvenente": this.objetoConvenio.nomeConvenente,
            "dataInicialVigencia": this.objetoConvenio.dataInicialVigencia,
            "dataFinalVigencia": this.objetoConvenio.dataFinalVigencia,
            "valor": this.objetoConvenio.valor,
            "saldoRemanescenteInstrumento": this.objetoConvenio.saldoRemanescenteInstrumento,
            "justificativaInstrumento": this.objetoConvenio.justificativaInstrumento,
            "saldoRemanescenteDevolvido": this.objetoConvenio.saldoRemanescenteDevolvido,
            "justificativaDevolvido": this.objetoConvenio.justificativaDevolvido,
            "dataDevolucaoSaldoRemanescente": this.objetoConvenio.dataDevolucaoSaldoRemanescente,
            "situacao": this.objetoConvenio.situacao,
            "justificativaSituacao": this.objetoConvenio.justificativaSituacao,
            "dataPublicacaoConvenio": this.objetoConvenio.dataPublicacaoConvenio,
            "extratos": [],
            "idModuloAnalise": 0 // alterar para codigo da pca
        }

        if (this.objetoConvenio.sacc != '' &&
            this.objetoConvenio.nomeConvenente != '' &&
            this.objetoConvenio.dataInicialVigencia != '' &&
            this.objetoConvenio.dataFinalVigencia != '' &&
            this.objetoConvenio.valor != '' &&
            this.objetoConvenio.dataPublicacaoConvenio != '') {
            check = true;
        } else {
            check = false;
        }

        if (check) {
            if (checkSituacao && checkDevolvido && checkInstrumento) {

                if (this.objetoEdit) {
                    let index = this.listaConvenio.indexOf(this.objetoEdit);
                    this.listaConvenio.splice(index, 1);

                    this.listEdit.push(this.objetoEdit);
                }

                this.selecionarTodosChecked = false;
                this.listaConvenio.push(objetoConvenio);

                this.objetoEdit = null;

                this.objetoConvenio.sacc = '';
                this.objetoConvenio.nomeConvenente = '';
                this.objetoConvenio.dataInicialVigencia = null;
                this.objetoConvenio.dataFinalVigencia = null;
                this.objetoConvenio.valor = '';
                this.objetoConvenio.saldoRemanescenteInstrumento = '';
                this.objetoConvenio.justificativaInstrumento = '';
                this.objetoConvenio.saldoRemanescenteDevolvido = '';
                this.objetoConvenio.dataDevolucaoSaldoRemanescente = null;
                this.objetoConvenio.situacao = '';
                this.objetoConvenio.justificativaDevolvido = '';
                this.objetoConvenio.justificativaSituacao = '';
                this.objetoConvenio.dataPublicacaoConvenio = null;

                this.clearDateRange();
            } else {
                this.alertService.mostraAlerta("", "As justificativas devem ser devidamente preenchidas.");
            }
        } else {
            this.alertService.mostraAlerta("", "Necessário o preenchimento de todos os campos.");
        }
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaResumo() {
        this.menuService.redirecionarPagina(this.convenioService.obterIdPaginaConvenio());
    }

    salvar() {

        this.listEdit.forEach(item => {
            this.remover(item, true);
        });

        this.listEdit = [];

        this.convenioService.salvarConvenioRelacaoCelebrado(this.listaConvenio).subscribe(data => {
            this.alertService.mostraAlerta("", "Convênio salvo com sucesso.");
            this.carregarModulo();
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar o convênio:" + error);
        });
    }

    finalizar() {

        this.listEdit.forEach(item => {
            this.remover(item, true);
        });

        this.listEdit = [];

        this.convenioService.finalizarConvenioRelacaoCelebrado(this.listaConvenio).subscribe(data => {
            this.alertService.mostraAlerta("", "Análise finalizada com sucesso.");
            this.voltarParaResumo();
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar a analise:" + error);
        });
    }

    remover(relacao, edit) {

        if (!edit) {

            this.alertService.mostraModalConfirmacao("Remover", "Deseja remover o item?", callback => {
                if (callback) {

                    let index = this.listaConvenio.indexOf(relacao);
                    this.listaConvenio.splice(index, 1);

                    if (relacao.idConveniosCelebrados != 0) {
                        this.deletaConvenio(relacao.idConveniosCelebrados);
                    }
                }
            });
        } else {
            if (relacao.idConveniosCelebrados != 0 && relacao.idConveniosCelebrados != undefined) {
                this.deletaConvenio(relacao.idConveniosCelebrados);
            }
        }
    }


    private deletaConvenio(idRelacao) {
        this.convenioService.deletarConvenioRelacaoCelebrado(idRelacao).subscribe(data => {

        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao remover o registro.:" + error);
        });
    }

    excluirSelecionados(){

        let qtdeSelecionados = 0; 
        this.listaConvenio.forEach(item => qtdeSelecionados += item.checked);
        
        if(qtdeSelecionados == 0) {
            this.alertService.mostraAlerta("", "Selecione pelo menos um registro para excluir!");
            return;
        }
    
        let registrosTexto = qtdeSelecionados + (qtdeSelecionados == 1 ? " registro?" : " registros?");
    
        this.alertService.mostraModalConfirmacao("Excluir " + registrosTexto, 
            "Deseja continuar com a exclusão de " 
                + registrosTexto + "<br/>" 
                + "Após a exclusão, os registros serão recarregados. Certifique-se de salvar possíveis alterações antes de prosseguir!", 
            callback => {            
                if (callback) {
                    this.loading = true;
                                        
                    let listaId = this.listaConvenio
                        .filter(item => item.checked)
                        .map(item => item.idConveniosCelebrados);
                    
                    this.convenioService.deletarRelacaoConveniosCelebradosLista(listaId, this.selecionarTodosChecked, this.idModuloAnalise).subscribe(data => {
                        this.listar();
                        this.alertService.mostraAlerta("", data.mensagem);
                    }, error => {
                        this.listar();
                        this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir: " + error.mensagem);
                    });
                }
            }
        );        
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 10;

        if (text != undefined) {
            let separatedByWords = text.toString().split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        let separatedByWords = text.toString().split(" ");
        let numberOfWordsToTruncate = 10;

        return separatedByWords.length >= numberOfWordsToTruncate;
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }

    templateCargaEmMassa() {
        let CodTemplate = 1 // Codigo do template.
        this.convenioService.downloadTemplateCargaMassa(CodTemplate);
    }

    cargaEmMassa(event) {
        this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?",
            retornoModal => {
                if (retornoModal) {
                    this.loading = true;
                    this.fileService.cargaRelacaoConvenios(event).subscribe(data => {
                        this.inputFileCMVar.nativeElement.value = "";
                        this.listaConvenio = data;
                        this.selecionarTodosChecked = false;
                        this.alertService.mostraAlerta("Importação concluída.","Para efetivar a importação, clique em salvar ou finalizar.");
                        this.loading = false;
                    }, error => {
                        this.inputFileCMVar.nativeElement.value = "";
                        this.alertService.mostraAlerta("Houve um erro ao carregar arquivo.", error.mensagem);
                        this.loading = false;
                    });
                }
            }
        );
    }

    abrirListarArquivo(item) {
        let titulo = "Peças Processuais";
        let modal = this.modalCtrl.create(ModalArquivosPage,
            {
                titulo: titulo,
                IdProcesso: item.idConveniosCelebrados,
                idModuloPCA: this.codigoModulo,
                tipoAnalise: '1211',
                jurisdicionado: this.isJurisdicionado,
                isCGE: this.isCGE,
                origemArquivo: "Nº SACC/SCC: " + item.sacc,
                origemFilter: 'EXTRATO CONTA CORRENTE',
                analise: this.analise
                //tipoEntidadeExercicio: ptipoEntidadeExercicio,
                //tipodocumento: pTipodocumento,
            });
        modal.onDidDismiss(retornoModal => {
            if (retornoModal && retornoModal.flag) {
            }
        });

        modal.present();
    }

    redirecionarParaAnalise(item) {

        let analise = this.navParams.get('analise');

        analise.idProcesso = item.idConveniosCelebrados;
        analise.cdAnalise = "1211"
        this.menuService.redirecionarSubPagina(this.convenioService.obterIdPaginaConvenio(), analise);
    }

    editar(item) {
        this.objetoConvenio.sacc = item.sacc;
        this.objetoConvenio.nomeConvenente = item.nomeConvenente;
        this.objetoConvenio.dataInicialVigencia = item.dataInicialVigencia;
        this.objetoConvenio.dataFinalVigencia = item.dataFinalVigencia;
        this.objetoConvenio.valor = item.valor;
        this.objetoConvenio.saldoRemanescenteInstrumento = item.saldoRemanescenteInstrumento;
        this.objetoConvenio.justificativaInstrumento = item.justificativaInstrumento;
        this.objetoConvenio.saldoRemanescenteDevolvido = item.saldoRemanescenteDevolvido;
        this.objetoConvenio.dataDevolucaoSaldoRemanescente = item.dataDevolucaoSaldoRemanescente == null ? '' : item.dataDevolucaoSaldoRemanescente;
        this.objetoConvenio.situacao = item.situacao;
        this.objetoConvenio.justificativaDevolvido = item.justificativaDevolvido;
        this.objetoConvenio.justificativaSituacao = item.justificativaSituacao;
        this.objetoConvenio.dataPublicacaoConvenio = item.dataPublicacaoConvenio;

        this.objetoEdit = item;
    }

    printData() {

        var doc = new jsPDF("l");
        var totalPagesExp = "{total_pages_count_string}";

        var pageContent = function (data) {
            // HEADER
            doc.setFontSize(20);
            doc.setTextColor(40);
            doc.setFontStyle('normal');

            doc.text("Relação dos Convênios/Ajustes Congêneres Celebrados/Aditados no Exercício", data.settings.margin.left + 15, 22);

            // FOOTER
            var str = "Page " + data.pageCount;
            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === 'function') {
                str = str + " of " + totalPagesExp;
            }
            doc.setFontSize(10);
            doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
        };

        var columns = [
            { title: "Nº Convênio E-Parcerias/SCC", dataKey: "nmConvenio" },
            { title: "Nome Convenente", dataKey: "nomeConv" },
            { title: "Início Vigência", dataKey: "inicioVig" },
            { title: "Fim Vigência", dataKey: "fimVig" },
            { title: "Valor Convênio", dataKey: "valorConv" },
            { title: "Data Pub. Convênio", dataKey: "dataPub" },
            { title: "Saldo Remanescente Instrumento", dataKey: "saldoRemIn" },
            //{ title: "Justificativa", dataKey: "justRemIn" },
            { title: "Saldo Remanescente Devolvido", dataKey: "saldoRemDev" },
            //{ title: "Justificativa", dataKey: "justRemDev" },
            { title: "Data Devolução", dataKey: "dataDev" },
            { title: "Situação", dataKey: "situacao" }
            //{ title: "Justificativa", dataKey: "justSit" }
        ];

        let rows = [];

        this.listaConvenio.forEach(contrato => {

            var item = {
                "nmConvenio": contrato.sacc,
                "nomeConv": contrato.nomeConvenente,
                "inicioVig": contrato.dataInicialVigencia,
                "fimVig": contrato.dataFinalVigencia,
                "valorConv": this.formatarValorNumerico(contrato.valor),
                "dataPub": contrato.dataPublicacaoConvenio,
                "saldoRemIn": this.formatarValorNumerico(contrato.saldoRemanescenteInstrumento),
                //"justRemIn": contrato.justificativaInstrumento,
                "saldoRemDev": this.formatarValorNumerico(contrato.saldoRemanescenteDevolvido),
                //"justRemDev": contrato.justificativaDevolvido,
                "dataDev": contrato.dataDevolucaoSaldoRemanescente,
                "situacao": contrato.situacao
                //"justSit": contrato.justificativaSituacao
            };

            rows.push(item);
        });

        doc.autoTable(columns, rows, {
            //     theme: 'grid',
            //     addPageContent: pageContent,
            //     margin: { top: 30 },
            //     styles: {
            //         overflow: 'linebreak', // visible, hidden, ellipsize or linebreak
            //         columnWidth: 'auto'
            //     }
            // });

            theme: 'grid',
            addPageContent: pageContent,
            margin: {
                top: 30,
                left: 5
            },
            styles: {
                overflow: 'linebreak',
                columnWidth: 'wrap',
                fontSize: 7
            },
            columnStyles: {
                text: { columnWidth: 'auto' }
            }
        });

        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }

        doc.save('relacao_celebrados.pdf');
    }

    modalEvidencias(item: any) {

        let titulo = "Evidências";
        let modal = this.modalCtrl.create(ModalArquivosPage,
            {
                titulo: titulo,
                IdProcesso: item.sacc,
                idModuloPCA: this.codigoModulo,
                tipoAnalise: 0,
                jurisdicionado: this.isJurisdicionado,
                isCGE: this.isCGE,
                origemArquivo: "Contrato: " + item.sacc,
                tipoEntidadeExercicio: 0,
                tipodocumento: 0,
                analise: this.analise
            });

        modal.present();

    }

    modalAditivo(item: any) {

        let titulo = "Aditivos e seus Termos de Referência";
        let modal = this.modalCtrl.create(ModalArquivosPage,
            {
                titulo: titulo,
                IdProcesso: item.idConveniosCelebrados + item.sacc,
                idModuloPCA: this.codigoModulo,
                tipoAnalise: 0,
                jurisdicionado: this.isJurisdicionado,
                isCGE: this.isCGE,
                origemArquivo: "Contrato: " + item.sacc,
                tipoEntidadeExercicio: 0,
                tipodocumento: 0,
                analise: this.analise
            });

        modal.present();

    }

    onSaldoRemanescenteUpdated(){
        console.log(this.objetoConvenio.saldoRemanescenteInstrumento);
    }

    selecionarTodos(){
        setTimeout(()=>{
            this.listaConvenio.forEach(
                item => item.checked = this.selecionarTodosChecked);            
        });
      }
    
      selecionarItem(){
          const totalItems = this.listaConvenio.length;
          let checked = 0;
          this.listaConvenio.map(obj => {
              if (obj.checked) checked++;
          });
          this.selecionarTodosChecked = checked == totalItems;
      }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/convenios/relacao-celebrados/relacao-celebrados.ts